module.exports = __webpack_public_path__ + "img/bg.74b821aa.jpg";